$(document).on('turbo:load turbo:render', () => {


    $(".multi-check-box").on("change", (e) =>{
        let $el = $(e.currentTarget);
        //@ts-ignore
        let checked = e.currentTarget.checked;
        $el.closest("table").find(":checkbox").each((i, el) =>{
            let $el = $(el);
            $el.prop("checked", checked)
        })

    });
});